import { render, staticRenderFns } from "./StateSelect.vue?vue&type=template&id=5dfd2d5d&scoped=true"
import script from "./StateSelect.vue?vue&type=script&lang=js"
export * from "./StateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd2d5d",
  null
  
)

export default component.exports